export default __webpack_public_path__ + "static/media/icon-singleCarry.8aaa20ec.svg";